module.exports = __webpack_public_path__ + "img/heart-blue.0df14e34.svg";